<template>
    <div class="box">
        <div class="user_bor">


            <div class="user_box">
                <div class="user_box_left">
                    {{$t('m.index_08')}}
                </div>
                <div class="user_box_right">

                </div>

            </div>


            <div class="collapse">
                <div v-for="item in list">
                    <el-collapse v-model="activeName" accordion>
                        <el-collapse-item>
                            <template slot="title">
                                <div style="width: 100%; padding-right: 20px;">
                                    <p style="float: left;">
                                        {{ item.title }}
                                    </p>
                                    <p align="right">
                                   {{ item.add_time }}
                                    </p>
                                </div>
                            </template>
                            <div class="collapsebox">
                            <div class="desc">
                                {{ item.desc }}
                            </div>

                        </div>
                        <div v-html="item.content"></div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
            <div class="foot_kongbox" v-if="list.length"></div>
            <state :label="label" v-if="!list.length"></state>


        </div>










    </div>
</template>
<script>
import state from '@/components/state.vue'
import encryption from '@/utils/encryption.js'
export default {
    components: {
        state
    },
    data() {
        return {
            label: 2,
            activeNames: ['1'],
            page: 1,
            list: []
        };
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        getData() {
            let param = {
                p: this.page
            }
            let sing = encryption.getSing(param)
            this.$api.help_list(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.list = res.data.data
                    this.list.forEach(item => {
                        item.add_time = this.$common.timetrans(item.add_time,true,'-','-','')
                    });
                    
                }
            })
        }
    },
    created() {

    },
    mounted() {
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
// .box{
//     min-width: 800px;
// }
.foot_kongbox {
    height: 100px;
}

.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;
    padding-left: 20px;

    .user_box_left {
        padding-left: 25px;
    }

}

.collapse {
    padding: 0 50px;
    margin-top: 30px;
}

::v-deep .el-collapse-item__header {
    margin-top: 10px;
    background-color: #f6f7fa;
    border: 1px solid #e5e5e5;
    padding-left: 20px;
    font-weight: bold !important;
    height: 55px;
    color: #4c5162;
    line-height: 55px;
}

::v-deep .el-collapse-item__content {
    div {
        margin-top: 6px;
    }
}

::v-deep .el-collapse {
    border: 0 !important;

}




::v-deep .el-collapse-item__header.is-active {
    border-bottom: 1px solid #e5e5e5;
}

::v-deep .el-collapse-item__wrap {
    padding: 20px;
    border: 1px solid #e5e5e5;

    margin-top: 10px;
}

::v-deep .el-collapse-item__arrow {
    font-weight: bold !important;
}

.collapsebox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-right: 50px;

    .desc {
        font-weight: bold;
    }

}


// 宽度小于1200px
@media screen and (max-width: 1200px){
	.user_box{padding: 0;}
	.collapse{
		margin-top: 0rem;padding: 0.6rem;
		::v-deep.el-collapse-item__header{
			height: auto!important;
			line-height: 1.5rem!important;
			padding: 1rem;
			div{
				p{
					&:last-child{
						text-align: left;	
						padding-top: 0.8rem;
					}
				}
			}
		}
	}
}
</style>